import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetBrandsListQueryResponse, GetBrandsList400, GetBrandsList500 } from "../types/GetBrandsList";

export const getBrandsListQueryKey = () =>     [{url:`/api/catalog/mainPage/brands`}] as const;
      export function getBrandsListQueryOptions <TData = GetBrandsListQueryResponse, TError = GetBrandsList400 | GetBrandsList500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getBrandsListQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/catalog/mainPage/brands`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение списка производителей
 * @link /api/catalog/mainPage/brands
 */

export function useGetBrandsList <TData = GetBrandsListQueryResponse, TError = GetBrandsList400 | GetBrandsList500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getBrandsListQueryKey();

  const query = useQuery<TData, TError>({
    ...getBrandsListQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
